(function ( $ ) {

	/*------------------------------------*\
	    DEVHUB SITEMAP
	    Interactive sitemap — add page modal, inline status editing,
	    next step buttons, delete rows. All actions via AJAX.

	    Requires: devhubAjax.ajaxUrl, devhubAjax.sitemapNonce
	\*------------------------------------*/

	$.fn.devhubSitemap = function () {

		var $wrap     = this;
		var sitemapId = $wrap.data( 'sitemap-id' );
		var nonce     = typeof devhubAjax !== 'undefined' ? devhubAjax.sitemapNonce : '';
		var ajaxUrl   = typeof devhubAjax !== 'undefined' ? devhubAjax.ajaxUrl     : '';

		// Status progression map
		var nextStatus = {
			'not-started': { label: 'Start Brief',     next: 'brief'      },
			'brief':       { label: 'Generate Mockup', next: 'mockup'     },
			'mockup':      { label: 'Gather Feedback', next: 'feedback'   },
			'feedback':    { label: 'Continue',        next: 'spec'       },
			'spec':        { label: 'Continue',        next: 'build'      },
			'build':       { label: 'Integrate',       next: 'integrated' },
			'integrated':  { label: 'Mark Complete',   next: 'complete'   }
		};

		var statusLabels = {
			'not-started': 'Not Started',
			'brief':       'Brief',
			'mockup':      'Mockup',
			'feedback':    'Feedback',
			'spec':        'Design Spec',
			'build':       'Build',
			'integrated':  'Integrated',
			'complete':    'Complete'
		};

		/* ── Update status badge in DOM ──────────────────────────── */

		function updateBadge( $badge, newStatus ) {

			// Strip old status modifier classes
			var classes = $badge.attr( 'class' ).split( ' ' );

			$.each( classes, function ( i, cls ) {

				if ( cls.indexOf( 'sitemap-status--' ) === 0 ) {
					$badge.removeClass( cls );
				}

			} );

			$badge.addClass( 'sitemap-status--' + newStatus );
			$badge.text( statusLabels[ newStatus ] || newStatus );
			$badge.data( 'status', newStatus );

		}

		/* ── Update next step label in DOM ──────────────────────── */

		function updateNextStepCell( $row, newStatus ) {

			var $cell = $row.find( '.sitemap-next-step-cell' );

			if ( ! $cell.length ) {
				return;
			}

			if ( newStatus === 'complete' ) {

				$cell.html( '<span class="sitemap-complete-check">&#10003;</span>' );

			} else if ( nextStatus[ newStatus ] ) {

				$cell.html( '<span class="sitemap-next-label">' + nextStatus[ newStatus ].label + '</span>' );

			} else {

				$cell.html( '' );

			}

		}

		/* ── Show prompt in modal ───────────────────────────────── */

		function showPromptModal( filename, content ) {

			var $modal = $( '.js-sitemap-prompt-modal' );

			$modal.find( '.js-prompt-filename' ).text( filename );
			$modal.find( '.js-prompt-content' ).text( content );
			$modal.show();

		}

		/* ── Build Prompt button click ───────────────────────────── */

		$wrap.on( 'click', '.js-sitemap-build-prompt', function () {

			var $btn          = $( this );
			var $row          = $btn.closest( 'tr' );
			var pageIndex     = $row.data( 'page-index' );
			var currentStatus = $row.data( 'status' ) || '';
			var newStatus     = $btn.data( 'next-status' );

			$btn.prop( 'disabled', true ).text( 'Building...' );

			$.ajax( {
				url:  ajaxUrl,
				type: 'POST',
				data: {
					action:         'sitemap_generate_handoff',
					nonce:          nonce,
					sitemap_id:     sitemapId,
					page_index:     pageIndex,
					current_status: currentStatus,
					next_status:    newStatus
				},
				success: function ( resp ) {

					if ( resp.success ) {

						// Replace Build Prompt button with View Prompt button
						$btn.replaceWith(
							$( '<button>' )
								.addClass( 'devhub-btn devhub-btn--small devhub-btn--ghost js-sitemap-view-prompt' )
								.attr( 'data-prompt-filename', resp.data.filename )
								.attr( 'type', 'button' )
								.text( 'View Prompt' )
						);

						showPromptModal( resp.data.filename, resp.data.content );

					} else {

						$btn.prop( 'disabled', false ).text( 'Error — retry' );

					}

				},
				error: function () {

					$btn.prop( 'disabled', false ).text( 'Error — retry' );

				}
			} );

		} );

		/* ── View Prompt button click ────────────────────────────── */

		$wrap.on( 'click', '.js-sitemap-view-prompt', function () {

			var $btn     = $( this );
			var filename = $btn.data( 'prompt-filename' );

			$btn.prop( 'disabled', true );

			$.post( ajaxUrl, {
				action:   'sitemap_view_prompt',
				filename: filename,
				nonce:    nonce
			}, function ( response ) {

				if ( response.success ) {
					showPromptModal( response.data.filename, response.data.content );
				}

				$btn.prop( 'disabled', false );

			} );

		} );

		/* ── Prompt modal close ──────────────────────────────────── */

		$( document ).on( 'click', '.js-sitemap-prompt-close', function () {

			$( '.js-sitemap-prompt-modal' ).hide();

		} );

		/* ── Copy to clipboard ───────────────────────────────────── */

		$wrap.on( 'click', '.js-prompt-copy', function () {

			var content = $( '.js-prompt-content' ).text();
			navigator.clipboard.writeText( content );
			$( this ).text( 'Copied!' );

			setTimeout( function () {
				$( '.js-prompt-copy' ).text( 'Copy to Clipboard' );
			}, 2000 );

		} );

		/* ── Delete page ─────────────────────────────────────────── */

		$wrap.on( 'click', '.js-sitemap-delete', function () {

			if ( ! window.confirm( 'Remove this page? This cannot be undone.' ) ) {
				return;
			}

			var $btn      = $( this );
			var $row      = $btn.closest( 'tr' );
			var pageIndex = $row.data( 'page-index' );

			$.ajax( {
				url:  ajaxUrl,
				type: 'POST',
				data: {
					action:     'sitemap_delete_page',
					nonce:      nonce,
					sitemap_id: sitemapId,
					page_index: pageIndex
				},
				success: function ( resp ) {

					if ( resp.success ) {
						$row.fadeOut( 250, function () { $( this ).remove(); } );
					}

				}
			} );

		} );

		/* ── Add Page button — open modal ────────────────────────── */

		$( document ).on( 'click', '.js-sitemap-add-page', function () {

			$( '.js-sitemap-modal' ).fadeIn( 200 );
			$( '.js-sitemap-new-name' ).focus();

		} );

		/* ── Modal close ─────────────────────────────────────────── */

		$( document ).on( 'click', '.js-sitemap-modal-close', function () {

			$( '.js-sitemap-modal' ).fadeOut( 150 );

		} );

		/* ── Modal save ──────────────────────────────────────────── */

		$( document ).on( 'click', '.js-sitemap-modal-save', function () {

			var pageName   = $.trim( $( '.js-sitemap-new-name' ).val() );
			var pageBucket = $( '.js-sitemap-new-bucket' ).val();

			if ( ! pageName ) {
				$( '.js-sitemap-new-name' ).focus();
				return;
			}

			var $btn = $( this );
			$btn.prop( 'disabled', true ).text( 'Adding...' );

			$.ajax( {
				url:  ajaxUrl,
				type: 'POST',
				data: {
					action:      'sitemap_add_page',
					nonce:       nonce,
					sitemap_id:  sitemapId,
					page_name:   pageName,
					page_bucket: pageBucket
				},
				success: function ( resp ) {

					if ( resp.success ) {
						// Reload to get the fully rendered row and updated diagram
						window.location.reload();
					} else {
						$btn.prop( 'disabled', false ).text( 'Add Page' );
					}

				},
				error: function () {

					$btn.prop( 'disabled', false ).text( 'Add Page' );

				}
			} );

		} );

		/* ── Enter key in modal name field ───────────────────────── */

		$( document ).on( 'keydown', '.js-sitemap-new-name', function ( e ) {

			if ( e.which === 13 ) {
				$( '.js-sitemap-modal-save' ).trigger( 'click' );
			}

		} );

		return this;

	};

}( jQuery ) );
